import CategoryTabs from './CategoryTabs';

export default CategoryTabs;
